<script setup lang="ts">
    import { ref, onMounted, watch } from "vue"
    import { DisplayStyle, ButtonDisplayStyle } from "../Enums/UiEnums"
    import { bootstrapTextClass } from  "../lib/StyleHelpers"

    const props = withDefaults(defineProps<{
            on?: boolean,
            titleFilterOn?: string,
            titleFilterOff?: string,
            displayStyle?: DisplayStyle | ButtonDisplayStyle
        }>(), {
            on: false,
            titleFilterOn: "Filter",
            titleFilterOff: "Clear filter",
            displayStyle: DisplayStyle.Primary
    });

    const _filterOn = ref(props.on);

    const emit = defineEmits(["change", "update:on"]);

    const emitChange = (newFilterOnVal: boolean) =>{ 
        _filterOn.value = newFilterOnVal;

        emit("update:on", newFilterOnVal);
        emit("change", newFilterOnVal); 
    }    

    onMounted(() => {
        _filterOn.value = props.on;
    });

    watch(() => props.on, (newVal, _oldVal) => {
        _filterOn.value = newVal;
    });
</script>

<style scoped>
    .filter-icon:hover 
    { 
        color: black; text-shadow: 0 0 5px lawngreen, 0 0 10px lawngreen, 0 0 20px lawngreen, 0 0 40px lawngreen; 
        cursor: pointer;
    }
</style>

<template>
    <em v-if="!_filterOn" 
        :class="`fa-solid fa-filter filter-icon ${bootstrapTextClass(displayStyle)}`"
        @click="emitChange(true)" 
        :title="titleFilterOff">
    </em>

    <em v-if="_filterOn" 
        :class="`fa-solid fa-filter-circle-xmark filter-icon ${bootstrapTextClass(displayStyle)}`"
        @click="emitChange(false)" 
        :title="titleFilterOn">
    </em>
</template>